<template>
    <div v-b-hover="handleHover" class="team-user-item round-extra-large">
        <a class="d-flex justify-content-around align-items-center">
            <div class="d-flex flex-row align-items-center flex-grow-1">
                <b-avatar
                    class="mr-1 cursor-pointer badge-minimal round-large"
                    variant="info"
                    :text="resolveInitials(user.name)"
                    badge
                    :badge-variant="resolveUserStatus(user.status)"
                    :src="user.pictureUrl"
                    size="34"
                    badge-offset="-3px"
                />
                {{ user.name }}
            </div>
            <b-button v-if="isHovered && hasStart" variant="primary" @click="createTeamChat(user.id)">
                {{ $t("team-chats.start-chat") }}
            </b-button>
            <b-button
                v-if="isHovered && !hasStart"
                variant="dark"
                class="ml-1 remove p-0"
                @click="removeUser(user.id, user.name)"
            >
                &times;
            </b-button>
        </a>
    </div>
</template>

<script>
import { BAvatar, BButton, BNav, BNavItem, BLink, BRow, BCol, BOverlay, BBadge, VBHover } from "bootstrap-vue";
import { isDynamicRouteActive } from "@core/utils/utils";
import { resolveUserStatus, resolveInitials } from "@/utils/users";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BNav,
        BNavItem,
        BAvatar,
        BButton,
        BLink,
        BRow,
        BCol,
        BOverlay,
        BBadge,
    },
    directives: {
        "b-hover": VBHover,
    },
    props: {
        user: Object,
        hasStart: Boolean,
    },
    data() {
        return {
            isHovered: false,
        };
    },
    methods: {
        handleHover(hovered) {
            this.isHovered = hovered;
        },

        createTeamChat(userId) {
            axios
                .post(`/team-chats`, {
                    type: "one_to_one",
                    participants: [
                        {
                            userId,
                        },
                    ],
                })
                .then((response) => {
                    this.$root.$router.push(`/team-chat/${response.data.id}`);

                    this.$emit("toggle-create-team-chat");

                    this.toast(this.$t("team-chats.create.success"), {
                        title: this.$t("team-chats.create.success-title"),
                        variant: "success",
                    });
                })
                .catch(() => {
                    this.toast(this.$t("team-chats.create.failure"), {
                        title: this.$t("team-chats.create.failure-title"),
                        variant: "danger",
                    });
                });
        },

        removeUser(id, name) {
            this.$bvModal
                .msgBoxConfirm(this.$t("team-chats.confirm.remove-user-text", { name }), {
                    title: this.$t("team-chats.confirm.remove-user-title", {
                        name,
                    }),
                    cancelTitle: this.$t("team-chats.confirm.cancel"),
                    cancelVariant: "light",
                    okTitle: this.$t("team-chats.confirm.remove"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                })
                .then((result) => {
                    if (result) {
                        this.$emit("remove-team-chat-user", id);
                    }
                });
        },
    },
    emits: ["remove-team-chat-user", "toggle-create-team-chat"],
    setup() {
        const toast = useToast();

        return {
            resolveUserStatus,
            resolveInitials,
            isDynamicRouteActive,
            toast,
        };
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/modules/team-chat/teamUserItem.scss";
</style>
